import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../context/breadcrumb.context'
import { IconList } from '../icon/icon'
import { Card } from '../card/card'
import { useLoad } from '../hooks/load'
import { useNotificationContext } from '../../context/notification/context'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { FormNew } from '../form-new/form'
import { FormNewTextConfirm } from '../form-new/form-text-confirm'
import { FormNewButtonSubmitBack } from '../form-new/form-button'
import { recycleErrorMessage } from '../error/server-message'
import { withReference } from '../error/error-notice'

export const RecycleEmpty = ({ useApiList, field1, parentURL }) => {
  const apiList = useApiList()
  const history = useHistory()

  const notificationContext = useNotificationContext()

  useLoad(() => apiList.get('deleted'), [])

  const items = useMemo(() => apiList.items.map(item => item[field1]), [apiList, field1])

  const handleSubmit = async () => {
    try {
      await apiList.delete(`empty`)
      notificationContext.toast.notify('empty success', 3000)
      history.replace(parentURL)
    } catch (err) {
      // Same reasoning as RecycleDelete: nothing here is retryable, so say
      // what happened via toast and go back to the list the same way a
      // success does.
      notificationContext.toast.notify(withReference(recycleErrorMessage(err, 'The recycle bin was already empty.'), err), 5000)
      history.replace(parentURL)
    }
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Permanently delete">
        <Card title="permanently delete">

          <div className='alert alert-warning my-2'>You are about to permanently delete the following items.</div>
          
          <div className='my-2'>
            <ul className='list-group list-group-flush'>
              {items.map((item, i) => (
                <li key={i} className='list-group-item'>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <FormNew enabled onSubmit={handleSubmit}>
            <FormNewTextConfirm name='confirm' confirmValue='delete all' autoFocus />
            <FormNewButtonSubmitBack submitText='Permanently Delete' backUrl={parentURL} />
          </FormNew>

        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
